import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import VistaFueraPanel from '@/views/VistaFueraPanel.vue'
import VistaPanel from '@/views/VistaPanel.vue'

import Inicio from '@/pages/Inicio'
import OlvideMiContrasena from '@/pages/OlvideMiContrasena.vue'
import CambiarMiContrasena from '@/pages/CambiarMiContrasena.vue'
import RegistroVerificado from '@/pages/RegistroVerificado.vue'
import Registro from '@/pages/Registro'
import Principal from '@/pages/Principal'
import PropiedadesSensor from '@/pages/PropiedadesSensor'
import Alertas from '@/pages/Alertas' 
import Grafica from '@/pages/Grafica'
import AcercaDe from '@/pages/AcercaDe'
import UserData from '@/pages/UserData'
import PaginaCondicionesLegales from '@/pages/PaginaCondicionesLegales'

Vue.use(VueRouter)

const routes = [
  // si no se encuentra la ruta, redirigimos a "raíz" /
  {
    path: '*',
    redirect: {
      path: '/'
    }
  },
  // Rutas externas: fuera del panel, antes de que el usuario inicie sesión
  {
    path: '/',
    meta: {
      esRutaPublica: true
    },
    component: VistaFueraPanel,
      // redirigir al panel si hay usuario Logado
      beforeEnter: (to, from, next) => {
        if (store.getters.usuarioLogado) {
          next( { path: '/panel', replace: true })
        } else {
          next()
        }
      },
    children: [
      {
        path: '',
        component: Inicio
      },
      {
        path: 'olvideMiContrasena',
        component: OlvideMiContrasena
      },
      {
        path: 'cambiarMiContrasena',
        component: CambiarMiContrasena
      },
      {
        path: 'registroVerificado',
        component: RegistroVerificado
      },
      {
        path: 'registro',
        component: Registro
      }
    ]
  },
  // Rutas de panel: Una vez que el usuario ha iniciado sesión
  {
    path: '/panel',
    meta: {
      name: 'Vista del panel',
    },
    component: VistaPanel,
    // añadir las rutas de panel en el array "children":
    children: [
      {
        path: 'logout',
        component: null
      },
      {
        name: 'inicio',
        path: '',
        component: Principal
      },
      {
        name: 'alertas',
        path: 'alertas',
        component: Alertas,
        meta: { titulo: 'Alertas' }
      },
      {
        name: 'grafica',
        path: 'grafica',
        component: Grafica,
        meta: { titulo: 'Gráfica' }
      },
      {
        name: 'userdata',
        path: 'userdata',
        component: UserData,
        meta: { titulo: 'Editar Usuario' }
      },
      {
        name: 'acercade',
        path: 'acercade',
        component: AcercaDe,
        meta: { titulo: 'Acerca de ...' }
      },
      {
        path: 'PaginaCondicionesLegales/:tipoPagina',
        name: 'PaginaCondicionesLegales',
        component: PaginaCondicionesLegales,
        meta: { titulo: 'Aviso legal' }
      },   
      {
        path: 'anadirSensor',
        name: 'anadirSensor',
        component: PropiedadesSensor,
        meta: { titulo: 'Añadir nuevo Sensor' }
      },  
      {        
        path: 'modificarSensor/:id',
        name: 'modificarSensor',
        component: PropiedadesSensor,
        meta: { titulo: 'Modificar Sensor' }
      },  
      
    ]
  },
]

const router = new VueRouter({
  mode: 'history', 
  base: process.env.BASE_URL,
  routes,

  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {

  let proximaRuta = true // true = permitir la navegacion

  // la idea es solo intervenir si hay que Redirigir o Denegar la navegacion,
  // ya que por defecto, haremos un "next()"
  if (!store.getters.usuarioLogado) { // si no hay usuario logado
    if (!to.matched.some(ruta => ruta.meta.esRutaPublica)) { // y a donde se dirige NO es una ruta publica (es decir, privada)
      proximaRuta = '/login' // redirigimos a la pagina de Login
    }
  } else if (store.getters.usuarioLogado) {
    if (to.path == '/panel/logout') { // se pretende navegar a la ruta especial de cierre de sesion?
      proximaRuta = false
      store.dispatch("CERRAR_SESION") // ejecutamos un cierre de sesion
    } else if (to.meta.atributoRolUsuarioNecesario && !store.state.usuario.atributosRol.includes (to.meta.atributoRolUsuarioNecesario))  {
      proximaRuta = false // el usuario no tiene permiso, denegamos la navegacion
      console.log ('El usuario no tiene permiso!!!')
    }
  }

  next (proximaRuta)
});

export default router
